import * as React from 'react';
import {
  withStyles,
} from '@material-ui/core';
import classNames from 'classnames';
import textToSvg from 'text-to-svg';
import FontTab from './fontTab';
import DrawTab from './drawTab';
import { STATIC_SERVER } from '../../../configurations';
import { logger } from '../../../logger';
import styles from './createSignature.styles';
import KeyboardImage from '../../../assets/keyboard.svg';
import DrawImage from '../../../assets/pen.svg';

type Props = {
  onSubmit: ({ signature: string, initials: string }) => void | Promise<void>,
  onClose: () => void,
  fullName: string,
  classes: Object,
};

// For certain fonts text-to-svg cuts the text.
// The function increases the SVG width by 10 and
// translates the svg image to the right by 5
export const editFontSVG = (svg: string) => {

  const widthRegex = /width="(.*?)"/;
  const svgWidthIncrease = 15;
  const pathRegex = /path/;

  let editedSVG = svg;

  let width = svg.match(widthRegex);
  if (width && width.length) {
    width = Number(width[0].trim().slice(6).replace(/['"]+/g, ''));
    editedSVG = editedSVG.replace(widthRegex, `width="${width + svgWidthIncrease}"`);
  }

  const path = editedSVG.match(pathRegex);
  if (path && path.length) {
    editedSVG = `${editedSVG.slice(0, path.index + 'path'.length)} transform="translate(5 0)"${editedSVG.slice(path.index + 'path'.length)}`;
  }

  return editedSVG;
};

class CreateSignatureC extends React.PureComponent<Props, { tab: number }> {

  state = {
    tab: 1,
  };

  handleTabSwitch = value => () => {
    this.setState({
      tab: value,
    });
  };

  handleSubmit = async ({ signature, initials, fontOption }: { signature: string, initials: string, fontOption: string } = {}) => {
    if (this.state.tab === 0) {
      const options = {
        x: 0, y: 0, fontSize: 25, anchor: 'top left',
      };
      const casedFontOption = fontOption.split('_').join('');

      const getSvg = text => new Promise((res) => {
        textToSvg.load(`/assets/fonts/${casedFontOption}-Regular.ttf`, (err, text2svg) => {
          logger.log(err);
          const svg = text2svg.getSVG(text, options);
          res(svg);
        });
      });

      let signatureSVG = await getSvg(signature);
      signatureSVG = editFontSVG(signatureSVG);
      let initialsSVG = await getSvg(initials);
      initialsSVG = editFontSVG(initialsSVG);
      this.props.onSubmit({
        signature: `data:image/svg+xml;base64,${btoa(signatureSVG)}`,
        initials: `data:image/svg+xml;base64,${btoa(initialsSVG)}`,
      });
    }

    if (this.state.tab === 1) {
      this.props.onSubmit({
        signature,
        initials,
      });
    }
  };

  render() {
    const { tab } = this.state;
    const {
      onClose, fullName, classes,
    } = this.props;
    return (
      <div className={classes.root}>
        <div>
          <div className={classes.header}>Create Your Stamps</div>
          <div className={classes.tabButtonContainer}>
            <div
              onKeyDown={this.handleTabSwitch(0)}
              onClick={this.handleTabSwitch(0)}
              tabIndex={0}
              role="button"
              className={classNames({
                [classes.activeTabButton]: tab === 0,
                [classes.tabButton]: true,
              })}
            >
              <KeyboardImage className={classes.tabButtonIcon} />
              Type
            </div>
            <div
              onKeyDown={this.handleTabSwitch(1)}
              onClick={this.handleTabSwitch(1)}
              tabIndex={0}
              role="button"
              className={classNames({
                [classes.activeTabButton]: tab === 1,
                [classes.tabButton]: true,
              })}
            >
              <DrawImage className={classes.tabButtonIcon} />
              Draw
            </div>
          </div>
        </div>
        {tab === 0
          && (
          <FontTab
            signature={fullName}
            initials={fullName.split(' ').map(w => w.slice(0, 1).toUpperCase()).join('')}
            onSubmit={this.handleSubmit}
            onClose={onClose}
          />
          )
        }
        {tab === 1
          && (
          <DrawTab
            onSubmit={this.handleSubmit}
            onClose={onClose}
          />
          )
        }
      </div>
    );
  }

}

export default withStyles(styles)(CreateSignatureC);
